/* import __COLOCATED_TEMPLATE__ from './unsaved-changes-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();